import { useState } from 'react'
import { Autocomplete, Box, Collapse, TextField } from '@mui/material'
import { matchSorter } from 'match-sorter'
import { useCropModalContext, useCropModalContextDispatch, setNotes, setTaskNotes } from '../context/crop-modal-context'
import { CROP_TASK_TYPES } from '../constants/crop-modal-constants'

const CROP_OPTION = { id: 'crop', label: 'Crop Notes' }

const filterTargetOptions = (options, { inputValue }) => {
  if (!inputValue) return options
  return matchSorter(options, inputValue, { keys: ['label'] })
}

export const CropNotesField = ({ effectiveTaskCodes }) => {
  const { notes, taskNotes, showNotes } = useCropModalContext()
  const dispatch = useCropModalContextDispatch()
  const [noteTarget, setNoteTarget] = useState(CROP_OPTION)

  // tasks that can have notes, harvest type is excluded
  const options = [
    CROP_OPTION,
    ...CROP_TASK_TYPES
      .filter(t => effectiveTaskCodes?.includes(t.code) && t.code !== 'harvest')
      .map(t => ({ id: t.code, label: t.name })),
  ]

  const isCrop = noteTarget.id === 'crop'
  const currentValue = isCrop ? notes : (taskNotes[noteTarget.id] ?? '')

  const handleChange = (e) => {
    const val = e.target.value || ''
    if (isCrop) {
      dispatch(setNotes({ notes: val }))
    } else {
      dispatch(setTaskNotes({ taskCode: noteTarget.id, notes: val }))
    }
  }

  return (
    <Collapse in={showNotes}>
      <Box sx={{ width: '100%', pt: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <Autocomplete
          size="small"
          disableClearable
          options={options}
          value={noteTarget}
          onChange={(_, newValue) => setNoteTarget(newValue)}
          filterOptions={filterTargetOptions}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Notes target"
              variant="filled"
            />
          )}
          sx={{ maxWidth: 200 }}
        />
        <TextField
          label="Notes"
          multiline
          maxRows={4}
          minRows={2}
          variant="filled"
          fullWidth
          value={currentValue}
          slotProps={{ htmlInput: { style: { resize: 'none' } } }}
          onChange={handleChange}
        />
      </Box>
    </Collapse>
  )
}
